import { memoize } from '@codeleap/utils'
import { View, Loading } from '@/components'

export const PageLoading = memoize(() => {
  return (
    <View style={['center', { height: '100vh', width: '100vw', overflow: 'hidden' }]}>
      <Loading />
    </View>
  )
})
